var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33.02 69.367h33.961v3.1602h-33.961z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 1.9883c-3.1016 0-3.8203 2.9414-6.0391 5.4414-7.0781 9.4805-10.941 21.078-10.941 32.922v13.18h33.961v-13.18c0-11.84-3.8203-23.441-10.898-32.922-2.2031-2.4805-2.9219-5.4414-6.082-5.4414zm9.2617 20.941c0 5.1211-4.1406 9.2812-9.2383 9.2812-5.1211 0-9.2812-4.1602-9.2812-9.2812 0-5.1211 4.1602-9.2812 9.2812-9.2812 5.0977 0 9.2383 4.1602 9.2383 9.2812z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.98 48.129v26.121l4.8984 3.0195c1.1797 0.73828 2.6992-0.12109 2.6992-1.5v-12.781c0-5.7812-2.7969-11.199-7.5977-14.859z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.422 62.988v12.781c0 1.3789 1.5195 2.2383 2.6992 1.5l4.8984-3.0195v-26.121c-4.8008 3.6602-7.5977 9.0781-7.5977 14.859z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.379 75.527-2.8789 20.039c8.8672 3.1641 17.328 3.3516 27.02 0l-2.8984-20.039z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.742 22.934c0 3.4688 2.8047 6.2734 6.2734 6.2734 3.4336 0 6.2422-2.8047 6.2422-6.2734s-2.8047-6.2734-6.2422-6.2734c-3.4688-0.003906-6.2734 2.8047-6.2734 6.2734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.02 56.539h33.961v9.8281h-33.961z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpLaunch);
export default __webpack_public_path__ + "static/media/np_launch.f0da8dd5bca4f13bea7987878d73f2b6.svg";
export { ForwardRef as ReactComponent };